import React from 'react'

import { AsyncSelect } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import * as ProductosCrud from 'services/producto.service'

const FilaBusquedaTemplate = ({
  esFilaActiva,
  tipoDeProductos,
  seleccionarProductoViaBusquedaHandler
}) => {
  const __adminContext = React.useContext(AdminContext)

  const loadProductosSelect = (inputValue, resolve) => {
    ProductosCrud.obtenerAsComprasSelect2({
      busqueda: inputValue,
      tipo: tipoDeProductos
    }).then(({ data }) => resolve(data))
  }

  return (
    <AsyncSelect
      selectId='productoSelect'
      loadOptions={loadProductosSelect}
      onChange={seleccionarProductoViaBusquedaHandler}
      defaultMenuIsOpen={
        esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra
      }
      autoFocus={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
    />
  )
}

export default React.memo(FilaBusquedaTemplate)
